import dynamic from "next/dynamic";

import { Skeleton } from "@/components/atoms";

const SwiperGalleryNoSSR = dynamic(() => import("./SwiperGallery"), {
  loading: () => <Skeleton height="100%" />,
});

export default SwiperGalleryNoSSR;
